
export const handleClientTextFilter = (txtFiltro, datosOriginales) => {
    const inputBuscar = txtFiltro?.toUpperCase();

    return datosOriginales?.filter((honorario) => {
        const id = honorario.id?.toString().toUpperCase();
        const abreviaciones = honorario.abreviaciones?.toString().toUpperCase();
        const descripcion = honorario.descripcion?.toUpperCase();
        const calificacionMonitoreo = honorario.clasificacionMonitoreo?.toUpperCase() || '';
        const tipoProfesional = honorario.tipoProfesional?.toUpperCase() || '';

        return (
            id.includes(inputBuscar) ||
            abreviaciones.includes(inputBuscar) ||
            descripcion.includes(inputBuscar) ||
            tipoProfesional.includes(inputBuscar) ||
            calificacionMonitoreo.includes(inputBuscar));
    });
}